<template>
    <v-container fluid>
        <div v-if="!loading" class="body-2 mb-12">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Users
            </v-row>
            <v-row class="subtitle-2" no-gutters>
                <v-col v-for="(item, index) in headers" :key="index"
                    class="text-center">
                    {{item}}
                </v-col>
            </v-row>
            <v-divider />
            <div v-for="user in users" :key="user.id">
                <v-row no-gutters>
                    <v-col class="text-center">{{ user.name }}</v-col>
                    <v-col class="text-center">{{ user.email }}</v-col>
                    <v-col class="text-center">{{ user.role }}</v-col>
                    <v-col class="text-center">{{ dateToString(user.createdAt) }}</v-col>
                    <v-col class="text-center">
                        <update-user :user="user" />
                        <delete-user :user="user" />  
                    </v-col>
                </v-row>
                <v-divider />
            </div>
        </div>
        <div v-else>
            <v-row class="mb-12" justify="center">
                <loader />
            </v-row>
        </div>
    </v-container>
</template>

<script>
import updateUser from '../../../components/admin/user/updateUser.vue';
import deleteUser from '../../../components/admin/user/deleteUser.vue';
import Loader from '../../../layouts/Loader.vue'
import { ConvertDateToString } from '../../../functions/common';

export default {
    name: 'Users',
    data() {
        return {
            headers: ['Name', 'Email', 'Role', 'Сreation date', 'Action'],
        }
    },
    computed: {
        users() {
            //console.log(this.$store.getters.users)
            return this.$store.getters.users;
        },
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        loggedIn() {
            return this.$store.getters.loggedIn
        }
    },
    watch: {
        loggedIn() {
            if (!this.loggedIn) {
                this.$router.push('/home');
            }
        }
    },
    methods: {
        dateToString(date) {
            return ConvertDateToString(date, this.locale);
        }
    },
    components: {
        Loader, updateUser, deleteUser
    },
    async created() {
        try {
           await this.$store.dispatch('fetchAllUsers'); 
        }
        catch(error) {
            console.log(error.message)
        }  
    }
}
</script>
